// src/components/TrackingSearch.jsx (actualizado)
import React, { useState } from 'react';

// En TrackingSearch.jsx - actualizar el estado local
const TrackingSearch = ({ onSearch, onRequestAuth, loading }) => {
  const [trackingNumber, setTrackingNumber] = useState('');
  const [lastSearched, setLastSearched] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (trackingNumber.trim() && trackingNumber.trim() !== lastSearched) {
      // ✅ AUTOMATIZAR EL # PARA NÚMEROS DE 4 DÍGITOS
      let formattedNumber = trackingNumber.trim();

      // Si son exactamente 4 dígitos, agregar el #
      if (/^\d{4}$/.test(formattedNumber)) {
        formattedNumber = `#${formattedNumber}`;
      }

      console.log('🔍 Número formateado:', formattedNumber);

      // Marcar como buscado para prevenir duplicados
      setLastSearched(formattedNumber);

      // ✅ MODIFICADO: Usar onSearch en lugar de onRequestAuth
      // para redirigir a la nueva ruta
      onSearch(formattedNumber);
    }
  };

  const getPlaceholder = () => {
    if (trackingNumber.startsWith('#') || /^\d{4}$/.test(trackingNumber))
      return 'Ej: 1234 (Tienda Packsys)';
    if (trackingNumber.startsWith('PACKSYS'))
      return 'Ej: PACKSYS-123456 (Venta Directa)';
    if (trackingNumber.startsWith('20000'))
      return 'Ej: 200001234567890 (Mercado Libre)';
    if (trackingNumber.includes('-') && trackingNumber.length > 10)
      return 'Ej: 123-4567890-1234567 (Amazon)';
    if (/^\d{10}$/.test(trackingNumber))
      return 'Ej: 0000503910 (Venta Directa)';
    return 'Ingresa tu número de seguimiento...';
  };

  const getInputClass = () => {
    const baseClass =
      'w-full bg-white/95 backdrop-blur-sm placeholder:text-slate-500 text-slate-800 text-base md:text-lg border-2 rounded-2xl px-4 md:px-6 py-3 md:py-4 transition-all duration-300 ease focus:outline-none focus:bg-white hover:border-white/50 shadow-2xl pr-32';

    // ✅ DETECTAR NÚMEROS DE 4 DÍGitos (Tienda Packsys)
    if (trackingNumber.startsWith('#') || /^\d{4}$/.test(trackingNumber))
      return `${baseClass} border-blue-400 focus:border-blue-500`;
    if (trackingNumber.startsWith('PACKSYS'))
      return `${baseClass} border-green-400 focus:border-green-500`;
    if (trackingNumber.startsWith('20000'))
      return `${baseClass} border-yellow-400 focus:border-yellow-500`;
    if (trackingNumber.includes('-'))
      return `${baseClass} border-orange-400 focus:border-orange-500`;
    return `${baseClass} border-white/30 focus:border-packsys-orange`;
  };

  // ✅ NUEVA FUNCIÓN: Formatear el display para mostrar solo números
  const formatDisplayValue = (value) => {
    // Si el valor empieza con #, mostrarlo sin el # para mejor UX
    if (value.startsWith('#')) {
      return value.substring(1);
    }
    return value;
  };

  // ✅ NUEVA FUNCIÓN: Manejar cambio manteniendo el # internamente
  const handleInputChange = (e) => {
    const value = e.target.value;

    // Si el valor original tenía #, mantenerlo internamente
    if (trackingNumber.startsWith('#') && !value.startsWith('#')) {
      setTrackingNumber(`#${value}`);
    } else {
      setTrackingNumber(value);
    }
  };

  return (
    <div className="w-full max-w-2xl mx-auto">
      <form onSubmit={handleSubmit} className="relative">
        <div className="relative w-full">
          <input
            type="text"
            value={formatDisplayValue(trackingNumber)}
            onChange={handleInputChange}
            className={getInputClass()}
            placeholder={getPlaceholder()}
            disabled={loading}
          />

          <button
            type="submit"
            disabled={loading || !trackingNumber.trim()}
            className="absolute top-1/2 right-1 transform -translate-y-1/2 flex items-center rounded-xl bg-packsys-orange py-2 md:py-3 px-4 md:px-6 border-2 border-transparent text-center text-sm md:text-lg font-semibold text-white transition-all duration-300 shadow-2xl hover:bg-orange-600 focus:bg-orange-600 active:bg-orange-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <div className="flex items-center">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                <span className="hidden sm:inline">Buscando...</span>
              </div>
            ) : (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  className="w-4 h-4 md:w-5 md:h-5 mr-1 md:mr-2 flex-shrink-0"
                >
                  <path
                    fillRule="evenodd"
                    d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="hidden sm:inline">Rastrear</span>
                <span className="sm:hidden">Buscar</span>
              </>
            )}
          </button>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mt-3">
          {/* ✅ ACTUALIZADO: Mostrar ejemplos sin # */}
          <span className="text-white/80 text-xs bg-white/20 px-2 py-1 rounded">
            1234
          </span>
          <span className="text-white/80 text-xs bg-white/20 px-2 py-1 rounded">
            PACKSYS-123456
          </span>
          <span className="text-white/80 text-xs bg-white/20 px-2 py-1 rounded">
            200001234567890
          </span>
          <span className="text-white/80 text-xs bg-white/20 px-2 py-1 rounded">
            0000503910
          </span>
        </div>

        {/* ✅ NUEVO: Información para usuarios */}
        <div className="mt-4 text-center">
          <p className="text-white/70 text-sm">
            <strong>Tip:</strong> Para pedidos de Tienda Packsys, ingresa solo
            los 4 números
          </p>
        </div>
      </form>
    </div>
  );
};

export default TrackingSearch;
